import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class TopicNetwork extends BaseIcon {
  getChildren = () => [
    <g fill={ this.getColor() }>
      <rect x="1" y="16" width="8" height="7" rx="1.79"/>
      <rect x="15" y="16" width="8" height="7" rx="1.79"/>
      <rect x="8" y="1" width="8" height="7" rx="1.79"/>
      <rect x="11" y="9" width="2" height="2"/>
      <rect x="4" y="13" width="2" height="2" transform="translate(-9 19) rotate(-90)"/>
      <rect x="18" y="13" width="2" height="2"/>
      <rect x="4" y="11" width="16" height="2"/>
    </g>
  ]
  getViewBox = () => '0 0 24 24'
}
